import About from '@/pages/mainpage/About.vue'
import Rent from '@/pages/mainpage/Rent.vue'
import Join from '@/pages/mainpage/Join.vue'
import Help from '@/pages/mainpage/Help.vue'
import HelpDetail from '@/pages/mainpage/HelpDetail.vue'



// 相关路由数组
export const mainpageRoutes = [
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/rent',
    name: 'Rent',
    component: Rent,
    meta: {
      title: '租赁中心'
    }
  },
  {
    path: '/join',
    name: 'Join',
    component: Join,
    meta: {
      title: '加入我们'
    }
  },
  {
    path: '/help',
    name: 'Help',
    component: Help,
    meta: {
      title: '帮助中心'
    }
  },
  {
    path: '/help/:id',
    name: 'HelpDetail',
    component: HelpDetail,
    meta: {
      title: '帮助中心详情'
    }
  },
]

export default mainpageRoutes



// WEBPACK FOOTER //
// ./src/router/mainpage.js